import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { PasswordRecoveryComponent } from './components/password-recovery/password-recovery.component';
import { CreateAccountComponent } from './components/create-account/create-account.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
   },
   {
    path: 'register',
    component: RegisterComponent,
   },
   {
    path: 'create-account',
    component: CreateAccountComponent,
   },
   {
    path: 'password-recovery',
    component: PasswordRecoveryComponent,
   },
];

export const AuthRoutes = RouterModule.forChild(routes);
